export enum DocumentType {
  expenseReport = 'expense_report',
  receipt = 'receipt',
  document = 'document',
  advancedExpense = 'advanced_expense',
  externalInvoice = 'external_invoice'
}
